import { Select, SelectProps } from 'antd';
import { FC } from 'react';
import './style.scss';
import SvgSelectDown from '../svg/SvgSelectDown';

export interface SelectWrapProps extends SelectProps {
  width?: number;
}

const SelectWrap: FC<SelectWrapProps> = (props) => {
  const { className, width, ...otherProps } = props;

  return (
    <>
      <Select
        {...otherProps}
        suffixIcon={<SvgSelectDown />}
        className={`custom_select ${width ? `width-${width}` : ''} ${className || ''}`}
      />
    </>
  );
};

export default SelectWrap;
